import $ from 'jquery';
import slick from 'slick-carousel'
$('.news-slider').slick({
  vertical: true,
  verticalSwiping: true,
  slidesToShow: 4,
  infinite: false,
  prevArrow: '<button type="button" class=""><i class="icon-arrow-light-up"></i></button>',
  nextArrow: '<button type="button" class=""><i class="icon-arrow-light-down"></i></button>',
  appendArrows: '.news-slider-arrows',
  responsive: [{
      breakpoint: 992,
      settings: {
        verticalSwiping: false,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        verticalSwiping: false,
      }
    }
  ]
});

$('.publications-slider').slick({
  vertical: true,
  verticalSwiping: true,
  slidesToShow: 6,
  infinite: false,
  prevArrow: '<button type="button" class=""><i class="icon-arrow-light-up"></i></button>',
  nextArrow: '<button type="button" class=""><i class="icon-arrow-light-down"></i></button>',
  appendArrows: '.publications-slider-arrows',
  responsive: [{
      breakpoint: 992,
      settings: {
        verticalSwiping: false,
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        verticalSwiping: false,
      }
    }
  ]
});